<ng-container *ngIf="!item.hidden">
  <li class="nav-item pcoded-menu-caption">
    <label style="font-size: 1.2em;">V{{version}}</label>
    <label *ngIf="Entorno != ''" style="font-size: 1.5em; align-content: center;">&nbsp;{{Entorno}}</label>
  </li>

  <li class="nav-item pcoded-menu-caption">
    <label>{{item.title}}</label>
    <label style="font-size: 1.5em;">&nbsp;{{titleRol}}</label>
  </li>

  <ng-container *ngFor="let item of item.children">
    <app-nav-group *ngIf="item.type=='group'" [item]="item"></app-nav-group>

    <app-nav-collapse *ngIf="item.type=='collapse' && (item.permisos.indexOf(rol)) > -1" [item]="item"></app-nav-collapse>

    <app-nav-item *ngIf="item.type=='item' && (item.permisos.indexOf(rol)) > -1" [item]="item"></app-nav-item>
  </ng-container>
</ng-container>